import { apiUrl, fetchJson } from '../../apiBase';

export async function getForestSummary(school, { className, monthKey } = {}) {
  const params = new URLSearchParams();
  if (className) params.set('class_name', className);
  if (monthKey) params.set('month_key', monthKey);
  const q = params.toString();
  const url = apiUrl(`/admin/vks/${encodeURIComponent(school)}/forest/summary${q ? `?${q}` : ''}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getForestDailyPulse(school, { className, localDate } = {}) {
  const params = new URLSearchParams();
  if (className) params.set('class_name', className);
  if (localDate) params.set('local_date', localDate);
  const q = params.toString();
  const url = apiUrl(`/admin/vks/${encodeURIComponent(school)}/forest/daily-pulse${q ? `?${q}` : ''}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getForestTeacherOverview(
  school,
  { className, monthKey, localDate, parentLimit } = {}
) {
  const params = new URLSearchParams();
  if (className) params.set('class_name', className);
  if (monthKey) params.set('month_key', monthKey);
  if (localDate) params.set('local_date', localDate);
  if (parentLimit !== undefined && parentLimit !== null) {
    params.set('parent_limit', String(parentLimit));
  }
  const q = params.toString();
  const url = apiUrl(
    `/admin/vks/${encodeURIComponent(school)}/forest/teacher-overview${q ? `?${q}` : ''}`
  );
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function sendForestMotivationMessage(
  school,
  { className, monthKey, audienceType, messageText, studentId, parentId } = {}
) {
  const payload = {
    class_name: className,
    month_key: monthKey,
    audience_type: audienceType,
    message_text: messageText,
  };
  if (studentId !== undefined && studentId !== null) payload.student_id = Number(studentId);
  if (parentId !== undefined && parentId !== null) payload.parent_id = Number(parentId);

  const url = apiUrl(`/admin/vks/${encodeURIComponent(school)}/forest/motivation/send`);
  const res = await fetchJson(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getTeacherAppreciationCandidates(
  school,
  { className, monthKey, limit = 5 } = {}
) {
  const params = new URLSearchParams();
  if (className) params.set('class_name', className);
  if (monthKey) params.set('month_key', monthKey);
  if (limit !== undefined && limit !== null) params.set('limit', String(limit));

  const q = params.toString();
  const url = apiUrl(
    `/admin/vks/${encodeURIComponent(school)}/teacher-appreciation/candidates${q ? `?${q}` : ''}`
  );
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
